import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { generateLoremIpsum } from './utils/loremIpsum'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const UNIT_LABELS = {
  paragraphs: 'Parágrafos',
  sentences: 'Frases',
  words: 'Palavras',
}

const LoremIpsumGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de Lorem Ipsum em Português  jarder.dev',
    description:
      'Gere texto de preenchimento (lorem ipsum) em português, por ' +
      'parágrafos, frases ou palavras. Grátis, direto no navegador.',
  })

  const [unit, setUnit] = useState('paragraphs')
  const [count, setCount] = useState('3')
  const [text, setText] = useState(() => generateLoremIpsum('paragraphs', 3))
  const [copied, setCopied] = useState(false)

  const generate = () => {
    const n = Math.max(1, Math.min(Number.parseInt(count, 10) || 1, 50))
    setText(generateLoremIpsum(unit, n))
    trackEvent('tool_generate', { tool: 'lorem_ipsum', unit, count: n })
  }

  const copy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      trackEvent('tool_copy', { tool: 'lorem_ipsum' })
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de Lorem Ipsum</h1>
      <p className="tool-disclaimer">
        Texto de preenchimento em português, para maquetes e protótipos.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="unit">Gerar por</label>
          <select
            id="unit"
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
          >
            {Object.entries(UNIT_LABELS).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div className="tool-field">
          <label htmlFor="count">Quantidade</label>
          <input
            id="count"
            type="number"
            min="1"
            max="50"
            value={count}
            onChange={(e) => setCount(e.target.value)}
          />
        </div>
      </div>

      <div className="tool-result-actions" style={{ marginBottom: 20 }}>
        <button type="button" className="tool-button" onClick={generate}>
          Gerar
        </button>
        <button
          type="button"
          className="tool-button tool-button-secondary"
          onClick={copy}
        >
          Copiar
        </button>
        {copied && <span className="tool-copied">Copiado!</span>}
      </div>

      <div className="tool-field">
        <textarea rows="14" readOnly value={text} />
      </div>

      <div className="tool-info-section">
        <h2>Para que serve o lorem ipsum</h2>
        <p>
          Texto de preenchimento é usado em maquetes e protótipos para
          mostrar como um layout vai se comportar com texto de verdade,
          sem que o conteúdo em si distraia de quem está avaliando o
          design. Diferente do lorem ipsum tradicional em latim
          pseudo-aleatório, este gerador produz texto em português, mais
          fácil de avaliar espaçamento e quebras de linha para um
          público brasileiro.
        </p>
      </div>
    </div>
  )
}

export default LoremIpsumGenerator
